import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';
import {LocationsService} from '../../../services/locations.service';

@Component({
  selector: 'app-new-location',
  templateUrl: './new-location.component.html',
  styleUrls: ['./new-location.component.scss']
})
export class NewLocationComponent implements OnInit {

  location = {};

  constructor(private graphqlService: LocationsService,
              private utilsService: UtilsService,
              private router: Router) {
  }

  ngOnInit() {

  }

  createLocation() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.location['name']);
    if (requiredSuccess) {
      this.graphqlService.create(this.location).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Location Created !!', '');
          this.router.navigate(['/locations']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create location.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/locations/new-location/new-location.component.ts